import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import VideocamIcon from '@material-ui/icons/Videocam';

const ITEMS = [
  {
    title: 'Dominio del Miedo Escénico',
    description:
      'Aprenderás técnicas probadas de control emocional y neuro-oratoria para que los nervios se conviertan en tu impulso y carisma. Proyecta seguridad en cualquier escenario.',
    Icon: RecordVoiceOverIcon,
  },
  {
    title: 'Arquitectura de Discursos',
    description:
      'Estructura ideas que conecten y transmitan emociones, que convenzan y muevan a tu audiencia a la acción, optimizadas para RRSS y presentaciones en público.',
    Icon: AccountTreeIcon,
  },
  {
    title: 'Storytelling y Emoción',
    description:
      'Aprende a usar el poder de las historias para humanizar tu mensaje y hacer que tus palabras sean experiencias imposibles de olvidar.',
    Icon: AutoStoriesIcon,
  },
  {
    title: 'Laboratorio de Práctica Real',
    description:
      'Sesiones 100% prácticas para mejorar dicción, lenguaje corporal y tono de voz con retroalimentación profesional inmediata. Incluye uso de micrófonos y cámaras, práctica grabada y la experiencia real de una cabina de radio/podcast.',
    Icon: VideocamIcon,
  },
];

const Pilares = () => {
  return (
    <Box py={{ xs: 2, md: 3 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="primary"
        align="center"
        display="block"
        gutterBottom
      >
        ¿Qué transformarás?
      </Typography>
      <Box component={Typography} fontWeight={800} variant="h4" gutterBottom align="center">
        Los pilares de la experiencia
      </Box>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        sx={{ maxWidth: 900, mx: 'auto', mb: 3 }}
      >
        Entrenas habilidades de presencia, estructura y conexión emocional, con práctica real y retroalimentación
        inmediata.
      </Typography>

      <Grid container spacing={2}>
        {ITEMS.map(({ title, description, Icon }) => (
          <Grid key={title} item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                height: '100%',
                p: 2.5,
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Box display="flex" gap={1.5} alignItems="flex-start">
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    flex: '0 0 auto',
                  }}
                >
                  <Icon />
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>
                    {title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {description}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Pilares;

